import * as React from 'react';
import { Link } from 'react-router-dom';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { ChiTooltip } from '../../../../components/utility/ChiTooltip';
import { formatCurrency } from '../../../../utils/currency-formatter';
import { DeliveryMethod } from '../../../../transportation/models/enums/delivery-method';
import { UnplannedRouteGroup } from '../../../../transportation/models/planning/unplanned-route-group';

interface IProps extends TSelectableItemProps {
    readonly        : boolean;
    delivery        : UnplannedRouteGroup;
    method          : DeliveryMethod;
    addressUrl      : string;
}

const UnplannedRouteRow = (props: IProps) => {

    const { selectableRef,
        isSelected,
        isSelecting,
        delivery
    } = props;

    let actualClass = 'order-selectable';
    actualClass += (delivery.isChecked) ? ' highlight' : '';
    actualClass += (isSelecting) ? ' dragging' : '';
    actualClass += (isSelected) ? ' selected-already' : '';

    const hasFreightError = () => props.delivery.freight < props.delivery.minimumFreight;
    const hasLongSections = () => props.delivery.longSections > 0;

    return <tr
        key={`upprtr-${delivery.tmpClientId}`}
        ref={selectableRef}
        className={`unplanned-delivery-row ${actualClass}`} >
        <td>
            <span>
                {`${props.delivery.deliveryAddress.name}`} <span>{'*'.repeat(props.delivery.orderGroupId)}</span>
            </span>
            {
                props.delivery.isBadAddress
                    ? <ChiTooltip
                        title="Address Issues"
                        body={<p>This address is missing key information and it needs to be corrected before you can plan this one.  Click the icon to fix this up.</p>}
                        content={<Link to={props.addressUrl}><i className="la la-warning punchthrough" /></Link>} />
                    : null
            }
            {
                props.delivery.deliveryAddress.isNew
                    ? <ChiTooltip
                        title="New Address"
                        body={<p>This address is new and has not yet been verified.  Click the icon if you want to have a look at it and ensure it all looks good.</p>}
                        content={<Link to={props.addressUrl}><i className="la la-flag-o punchthrough" /></Link>} />
                    : null
            }
        </td>
        <td className="table-cell-center">
            {props.delivery.deliveryAddress.isJobSite ? 'X' : ''}
        </td>
        <td>
            {props.delivery.deliveryAddress.city}
        </td>
        <td className="table-cell-center">
            {props.delivery.deliveryAddress.stateProvince}
        </td>
        <td className="table-cell-center">
            {props.delivery.units}
        </td>
        <td className="table-cell-center">
            {props.delivery.singles}
        </td>
        <td className={`table-cell-center ${hasLongSections() ? 'long-door-error' : ''} `}>
            {props.delivery.sections}
            {
                hasLongSections()
                    ? <ChiTooltip
                        title="Has Long Sections"
                        body={<p>This order has {props.delivery.longSections} long sections.</p>}
                        content={<span className="longsection-error-overlay" />}
                    />
                    : null
            }
        </td>
        <td className="table-cell-center">
            {props.delivery.feet}
        </td>
        <td className="table-cell-center">
            {props.delivery.weight}
        </td>
        <td className={`table-cell-center ${hasFreightError() ? 'freight-error' : ''}`}>
            {formatCurrency(props.delivery.freight)}
            {
                hasFreightError()
                    ? <ChiTooltip
                        title="Min Freight Not Met"
                        body={<p>The min freight of {formatCurrency(props.delivery.minimumFreight)} has not been met.</p>}
                        content={<span className="freight-error-overlay" />}
                    />
                    : null
            }
        </td>
    </tr>;

};

export default createSelectable(UnplannedRouteRow);
